import { render } from "./AnimalPuzzle.vue?vue&type=template&id=386b8c54&scoped=true"
import script from "./AnimalPuzzle.vue?vue&type=script&lang=js"
export * from "./AnimalPuzzle.vue?vue&type=script&lang=js"

import "./AnimalPuzzle.vue?vue&type=style&index=0&id=386b8c54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-386b8c54"]])

export default __exports__